var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-profile-page',[_c('wallet-account',{attrs:{"type":"individual","account-id":_vm.profile.wallet_account_id,"metadata":[{ key: 'user', value: _vm.profile.id }]},on:{"wallet-account-created":_vm.accountCreated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }